// extracted by mini-css-extract-plugin
module.exports = {"chapter":"restrict-lesson_chapter__21F_0","title":"restrict-lesson_title__3Iogt","icon":"restrict-lesson_icon__11bdC","description":"restrict-lesson_description__2Qakf"};